<p-dropdown
    [options]="options"
    [formControl]="control"
    optionValue="value"
    optionLabel="label"
    styleClass="custom-dropdown"
    [class]="class"
    [styleClass]="styleClass"
    [panelStyleClass]="panelStyleClass"
  >
  </p-dropdown>